/*
 * Velour — Hızlı Bakış (quick view).
 * Ürün kartındaki [data-vl-quick-view] tetikleyicisine delegated click ile bağlanır,
 * /products/{handle}.js JSON'unu çekip modali doldurur (galeri + başlık + fiyat +
 * variant seçenekleri + adet + Sepete Ekle). Sepete Ekle butonu kart ile AYNI
 * akışa bağlanır: form[data-vl-add-form] + button.vl-card__add-btn → vl-product-card.js'in
 * global delegated submit listener'ı cart-drawer'ı açar. Global scope kirletmez.
 */
(function () {
  'use strict';

  var modal = document.querySelector('[data-vl-qv]');
  if (!modal) return;

  var dialog = modal.querySelector('[data-vl-qv-dialog]');
  var loadingEl = modal.querySelector('[data-vl-qv-loading]');
  var contentEl = modal.querySelector('[data-vl-qv-content]');
  var lastFocused = null;

  // Aynı ürün ikinci kez açıldığında yeniden fetch etmemek için basit cache.
  var productCache = Object.create(null);

  // Sepet fiyatı önizlemesi ayarları (server-side data attribute'larından).
  var cp = (function () {
    if (modal.getAttribute('data-vl-cp-enabled') !== 'true') return null;
    function num(attr) {
      return parseInt(modal.getAttribute(attr), 10) || 0;
    }
    return {
      global: num('data-vl-cp-global'),
      tags: [
        { tag: modal.getAttribute('data-vl-cp-tag1') || '', pct: num('data-vl-cp-pct1') },
        { tag: modal.getAttribute('data-vl-cp-tag2') || '', pct: num('data-vl-cp-pct2') },
        { tag: modal.getAttribute('data-vl-cp-tag3') || '', pct: num('data-vl-cp-pct3') },
      ],
      label: modal.getAttribute('data-vl-cp-label') || 'Sepette fırsat fiyatı',
      color: modal.getAttribute('data-vl-cp-color') || '#B59778',
    };
  })();

  function cartPreviewCents(product, variant) {
    if (!cp || !variant || !variant.available) return 0;
    var percent = 0;
    if (cp.global > 0) {
      percent = cp.global;
    } else {
      var tags = (product.tags || []).map(function (t) {
        return String(t).toLowerCase();
      });
      for (var i = 0; i < cp.tags.length; i++) {
        var entry = cp.tags[i];
        if (entry.tag && tags.indexOf(entry.tag.toLowerCase()) !== -1) {
          percent = entry.pct;
          break;
        }
      }
    }
    if (percent <= 0) return 0;
    return Math.round((variant.price * (100 - percent)) / 100);
  }

  function moneyFormat(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt = (window.theme && window.theme.moneyFormat) || '{{amount}}';
      try {
        return window.Shopify.formatMoney(cents, fmt);
      } catch (e) {
        /* fallthrough */
      }
    }
    var value = (cents / 100).toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return value + ' TL';
  }

  function openModal() {
    lastFocused = document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vl-qv-open');
    if (typeof trapFocus === 'function' && dialog) {
      trapFocus(dialog);
    } else if (dialog) {
      dialog.focus();
    }
    document.addEventListener('keydown', onKeydown);
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vl-qv-open');
    document.removeEventListener('keydown', onKeydown);
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(lastFocused);
    } else if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closeModal();
  }

  function showLoading() {
    if (loadingEl) loadingEl.hidden = false;
    if (contentEl) {
      contentEl.hidden = true;
      contentEl.innerHTML = '';
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildOptions(product) {
    if (product.variants.length <= 1 || !product.options || product.has_only_default_variant) {
      return '';
    }
    var html = '';
    product.options.forEach(function (opt, optIndex) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var values = (typeof opt === 'string' ? product.options_with_values : null);
      // /products/{handle}.js → options: ["Beden"], variants[].option1/2/3
      var seen = {};
      var optionValues = [];
      product.variants.forEach(function (v) {
        var val = v['option' + (optIndex + 1)];
        if (val != null && !seen[val]) {
          seen[val] = true;
          optionValues.push(val);
        }
      });
      html +=
        '<div class="vl-qv__option">' +
        '<label class="vl-qv__option-label">' + escapeHtml(name) + '</label>' +
        '<select class="vl-qv__option-select" data-vl-qv-option="' + optIndex + '">';
      optionValues.forEach(function (val) {
        html += '<option value="' + escapeHtml(val) + '">' + escapeHtml(val) + '</option>';
      });
      html += '</select></div>';
    });
    return html;
  }

  function resolveVariant(product) {
    var selects = contentEl.querySelectorAll('[data-vl-qv-option]');
    if (!selects.length) {
      return product.variants[0];
    }
    var chosen = [];
    selects.forEach(function (sel) {
      chosen[parseInt(sel.getAttribute('data-vl-qv-option'), 10)] = sel.value;
    });
    return (
      product.variants.filter(function (v) {
        for (var i = 0; i < chosen.length; i++) {
          if (chosen[i] != null && v['option' + (i + 1)] !== chosen[i]) return false;
        }
        return true;
      })[0] || product.variants[0]
    );
  }

  function updateVariantState(product) {
    var variant = resolveVariant(product);
    var idInput = contentEl.querySelector('[data-vl-qv-id]');
    var priceEl = contentEl.querySelector('[data-vl-qv-price]');
    var btn = contentEl.querySelector('.vl-card__add-btn');
    var previewEl = contentEl.querySelector('[data-vl-qv-preview]');
    var stockEl = contentEl.querySelector('[data-vl-qv-stock]');
    if (idInput) idInput.value = variant ? variant.id : '';
    if (priceEl && variant) {
      var html = moneyFormat(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html =
          '<span class="vl-qv__price-sale">' + moneyFormat(variant.price) + '</span>' +
          '<s class="vl-qv__price-compare">' + moneyFormat(variant.compare_at_price) + '</s>';
      }
      priceEl.innerHTML = html;
    }
    if (previewEl) {
      var previewCents = cartPreviewCents(product, variant);
      if (previewCents > 0) {
        previewEl.innerHTML =
          '<span class="vl-cart-preview__label">' + escapeHtml(cp.label) + '</span>' +
          '<span class="vl-cart-preview__amount">' + moneyFormat(previewCents) + '</span>';
        previewEl.hidden = false;
      } else {
        previewEl.innerHTML = '';
        previewEl.hidden = true;
      }
    }
    if (stockEl) {
      if (variant && variant.available && typeof variant.inventory_quantity === 'number' &&
          variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
        stockEl.textContent = 'Son ' + variant.inventory_quantity + ' adet';
        stockEl.hidden = false;
      } else {
        stockEl.textContent = '';
        stockEl.hidden = true;
      }
    }
    if (btn) {
      var available = variant && variant.available;
      btn.disabled = !available;
      var label = btn.querySelector('[data-vl-add-label]');
      if (label) label.textContent = available ? 'Sepete ekle' : 'Tükendi';
    }
  }

  function render(product) {
    var imgSrc = product.featured_image || (product.images && product.images[0]) || '';
    var optionsHtml = buildOptions(product);

    var html =
      '<div class="vl-qv__grid">' +
        '<div class="vl-qv__media">' +
          (imgSrc
            ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(product.title) + '" width="600" height="900" loading="lazy">'
            : '') +
        '</div>' +
        '<div class="vl-qv__details">' +
          (product.vendor
            ? '<span class="vl-qv__vendor">' + escapeHtml(product.vendor) + '</span>'
            : '') +
          '<h2 class="vl-qv__title">' + escapeHtml(product.title) + '</h2>' +
          '<div class="vl-qv__price" data-vl-qv-price></div>' +
          (cp
            ? '<div class="vl-cart-preview vl-cart-preview--pdp vl-qv__preview" data-vl-qv-preview hidden style="--vl-cp-color: ' + escapeHtml(cp.color) + ';"></div>'
            : '') +
          '<p class="vl-qv__stock" data-vl-qv-stock hidden></p>' +
          optionsHtml +
          '<form class="vl-qv__form" data-vl-add-form data-product-id="' + product.id + '">' +
            '<input type="hidden" name="id" value="" data-vl-qv-id>' +
            '<input type="hidden" name="quantity" value="1">' +
            '<button type="submit" class="vl-card__add-btn vl-qv__add-btn">' +
              '<span class="vl-card__add-label" data-vl-add-label>Sepete ekle</span>' +
              '<span class="vl-card__add-spinner" data-vl-add-spinner aria-hidden="true"></span>' +
            '</button>' +
          '</form>' +
          '<a class="vl-qv__full-link" href="' + escapeHtml(product.url) + '">Ürün detayına git →</a>' +
        '</div>' +
      '</div>';

    contentEl.innerHTML = html;
    contentEl.hidden = false;
    if (loadingEl) loadingEl.hidden = true;

    contentEl.querySelectorAll('[data-vl-qv-option]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        updateVariantState(product);
      });
    });
    updateVariantState(product);
  }

  function loadProduct(handle) {
    openModal();
    // Cache hit → fetch yapma, doğrudan render et.
    if (productCache[handle]) {
      render(productCache[handle]);
      return;
    }
    showLoading();
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('quick-view fetch failed');
        return res.json();
      })
      .then(function (product) {
        productCache[handle] = product;
        render(product);
      })
      .catch(function (err) {
        console.error(err);
        if (contentEl) {
          contentEl.hidden = false;
          contentEl.innerHTML = '<p class="vl-qv__error">Ürün yüklenemedi. Lütfen ürün sayfasını açın.</p>';
        }
        if (loadingEl) loadingEl.hidden = true;
      });
  }

  // Kart üzerindeki tetikleyici (delegated)
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-vl-quick-view]');
    if (trigger) {
      event.preventDefault();
      var handle = trigger.getAttribute('data-product-handle');
      if (handle) loadProduct(handle);
      return;
    }
    if (event.target.closest('[data-vl-qv-close]')) {
      closeModal();
    }
  });

  // Sepete eklenince (vl-product-card.js publish ediyor) modali kapat → drawer açılır.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      if (payload && payload.source === 'vl-product-card' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });
  }
})();
